import { inject, Injectable } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService, User } from 'src/service/auth/auth.service';
import { UserRoles } from 'src/models/user-roles';
import { CloseScrollStrategy } from '@angular/cdk/overlay';

interface MenuItem {
  navItems: NavigationItem[];
  role: UserRoles;
}

const menuItems: MenuItem[] = [
  { 
    role: UserRoles.ADMIN,
    navItems: [
      {
        type: 'subheading',
        label: 'Dashboards',
        children: [
          {
            type: 'link',
            label: 'Probation Dashboard',
            route: '/dashboards/probation-officer',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Labs Dashboard',
            route: '/dashboards/admin',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Donor Management',
        children: [
          {
            type: 'link',
            label: 'Organizations',
            route: '/apps/organization-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Admin Staff',
            route: '/apps/probation-staff-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Donors',
            route: '/apps/probationer-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Compliance Management',
            route: '/apps/compliance-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
           ]
      },
      {
        type: 'subheading',
        label: 'Labs Management',
        children: [
           {
            type: 'link',
            label: 'Test Types',
            route: '/apps/test-type-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Labs',
            route: '/apps/labs-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
         
          {
            type: 'link',
            label: 'Lab Staff',
            route: '/apps/lab-staff-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
          ]
      },
      {
        type: 'subheading',
        label: 'Test Management',
        children: [
          {
            type: 'link',
            label: 'Today\'s Lab Tests',
            route: '/apps/today-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Tomorrow\'s Lab Tests',
            route: '/apps/next-day-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Lab Tests Browser',
            route: '/apps/lab-test-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      {
        type: 'subheading',
        label: 'System',
        children: [
          {
            type: 'link',
            label: 'Account Settings',
            route: '/apps/account-settings',
            icon: 'mat:settings',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'User Guide',
            route: '/apps/admin-user-guide',
            icon: 'mat:help',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      }
    ]
  },
  { 
    role: UserRoles.PROBATION_DIRECTOR,
    navItems: [
      {
        type: 'subheading',
        label: 'Dashboards',
        children: [
          {
            type: 'link',
            label: 'Probation Dashboard',
            route: '/dashboards/probation-officer',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Donor Management',
        children: [
          {
            type: 'link',
            label: 'Admin Staff',
            route: '/apps/probation-staff-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Donors',
            route: '/apps/probationer-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Compliance Management',
            route: '/apps/compliance-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
           ]
      },
      {
        type: 'subheading',
        label: 'Test Management',
        children: [
          {
            type: 'link',
            label: 'Today\'s Lab Tests',
            route: '/apps/today-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Tomorrow\'s Lab Tests',
            route: '/apps/next-day-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Lab Tests Browser',
            route: '/apps/lab-test-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Help',
        children: [
          {
            type: 'link',
            label: 'User Guide',
            route: '/apps/probation-director-user-guide',
            icon: 'mat:help',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
    ]
    
  },
  { 
    role: UserRoles.PROBATION_OFFICER,
    navItems:  [
      {
        type: 'subheading',
        label: 'Dashboards',
        children: [
          {
            type: 'link',
            label: 'Probation Dashboard',
            route: '/dashboards/probation-officer',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Donor Management',
        children: [
          {
            type: 'link',
            label: 'Donors',
            route: '/apps/probationer-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Compliance Management',
            route: '/apps/compliance-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
           ]
      },
      {
        type: 'subheading',
        label: 'Test Management',
        children: [
          {
            type: 'link',
            label: 'Today\'s Lab Tests',
            route: '/apps/today-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Tomorrow\'s Lab Tests',
            route: '/apps/next-day-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          
        ]
      },
      {
        type: 'subheading',
        label: 'Help',
        children: [
          {
            type: 'link',
            label: 'User Guide',
            route: '/apps/probation-officer-user-guide',
            icon: 'mat:help',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
    ]
  },
  {
    role: UserRoles.LAB_MANAGER,
    navItems: [
      {
        type: 'subheading',
        label: 'Dashboards',
        children: [
          {
            type: 'link',
            label: 'Labs Dashboard',
            route: '/dashboards/admin',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      
      {
        type: 'subheading',
        label: 'Labs Management',
        children: [
           {
            type: 'link',
            label: 'Test Types',
            route: '/apps/test-type-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Labs',
            route: '/apps/labs-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
         
          {
            type: 'link',
            label: 'Lab Staff',
            route: '/apps/lab-staff-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
          ]
      },
      {
        type: 'subheading',
        label: 'Test Management',
        children: [
          {
            type: 'link',
            label: 'Today\'s Lab Tests',
            route: '/apps/today-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Tomorrow\'s Lab Tests',
            route: '/apps/next-day-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Lab Tests Browser',
            route: '/apps/lab-test-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Help',
        children: [
          {
            type: 'link',
            label: 'User Guide',
            route: '/apps/lab-manager-user-guide',
            icon: 'mat:help',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
    ]
  },
  {
    role: UserRoles.LAB_TECHNICIAN,
    navItems:  [
      {
        type: 'subheading',
        label: 'Dashboards',
        children: [
          {
            type: 'link',
            label: 'Labs Dashboard',
            route: '/dashboards/admin',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      
      {
        type: 'subheading',
        label: 'Labs Management',
        children: [
           {
            type: 'link',
            label: 'Test Types',
            route: '/apps/test-type-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
          {
            type: 'link',
            label: 'Labs',
            route: '/apps/labs-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
         
          {
            type: 'link',
            label: 'Lab Staff',
            route: '/apps/lab-staff-management',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          }
          ]
      },
      {
        type: 'subheading',
        label: 'Test Management',
        children: [
          {
            type: 'link',
            label: 'Today\'s Lab Tests',
            route: '/apps/today-tests',
            icon: 'mat:insights',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Help',
        children: [
          {
            type: 'link',
            label: 'User Guide',
            route: '/apps/lab-technician-user-guide',
            icon: 'mat:help',
            routerLinkActiveOptions: { exact: true }
          },
        ]
      },
    ]
  }
  ];


@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }
  private role: UserRoles
  private authSvc: AuthService;
  constructor(private readonly layoutService: VexLayoutService) {
    this.authSvc = inject(AuthService)
    this.role = this.authSvc.loggedInUser.role
    console.log("Nav UserRole: " + this.role)
    this.loadNavigation();
  }
   
  loadNavigation(): void {
    this.role = this.authSvc.loggedInUser.role
    console.log("Nav UserRole: " + this.role)
    //TBD: This will become a generic check later.
    console.log(menuItems)
    let menus: NavigationItem[] | undefined =  menuItems.find(item => item.role === this.role)?.navItems;
    if (menus != null) {
      // find all the submenus with label = Probation Staff and replace it with current logged in user.getOrgUserStaffTypeString 
      menus.forEach((menu) => {
        if (menu.type === 'subheading') {
          menu.children?.forEach((child) => {
            if (child.label === 'Probation Staff') {
              child.label = this.authSvc.orgUserStaffTypeString
            }
            if (child.label === 'Probationer') {
              child.label = this.authSvc.orgUserTypeString
            }
            if (child.label === 'Probation Dashboard') {
              child.label = this.authSvc.orgUserTypeString + " Dashboard"
            }
          });
        }
      });

      this._items.next(menus)
    } else {
      console.error("No Menu Items for the role of current user")
    }
  } 
}
